// apps/client/src/pages/app/components/TransactionQuotaDisplay.tsx

import { Box, Button, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useProject } from '../../../contexts/ProjectContext';
import { getTransactionQuotaInfo } from '../../../utils/quota';

export const TransactionQuotaDisplay: React.FC = ({}) => {
  const { currentOrganisation } = useAuth();
  const { currentProject } = useProject();

  if (!currentOrganisation || !currentProject) return null;

  const quotaInfo = getTransactionQuotaInfo(currentOrganisation, currentProject.transactionCount);

  // Don't show if unlimited
  if (quotaInfo.isUnlimited) return null;

  const percentage = (quotaInfo.current / quotaInfo.limit) * 100;
  const progressColor = quotaInfo.isAtLimit
    ? 'error'
    : quotaInfo.isNearLimit
      ? 'warning'
      : 'primary';

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {(quotaInfo.isAtLimit || quotaInfo.isNearLimit) && (
        <Button
          component={RouterLink}
          to="/settings/plan"
          size="small"
          variant="outlined"
          color={quotaInfo.isAtLimit ? 'error' : 'warning'}
          sx={{
            whiteSpace: 'nowrap',
            fontSize: '0.7rem',
            padding: '2px 8px',
            minWidth: 'auto',
          }}
        >
          Upgrade to add more
        </Button>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 200 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="caption" fontWeight="medium">
            {quotaInfo.current}/{quotaInfo.limit} transactions
          </Typography>
          {/* {quotaInfo.remaining !== Infinity && quotaInfo.remaining > 0 && (
            <Typography variant="caption" color="text.secondary">
              {quotaInfo.remaining} remaining
            </Typography>
          )} */}
        </Box>
        <LinearProgress
          variant="determinate"
          value={Math.min(percentage, 100)}
          color={progressColor}
          sx={{
            height: 6,
            borderRadius: 1,
            backgroundColor: 'action.hover',
          }}
        />
      </Box>
    </Box>
  );
};

export default TransactionQuotaDisplay;
